import { SagaIterator } from 'redux-saga';
import { BASEDATA_CHANGE } from 'src/modules/basedata/actions/BasedataActions';
import { basedataChangeSaga } from 'src/modules/basedata/sagas/basedataChangeSaga';
import { takeLatest } from 'typed-redux-saga';

export function* basedataSaga(): SagaIterator<void> {
  yield* takeLatest(BASEDATA_CHANGE.is, basedataChangeSaga);
}
